// removed by extract-text-webpack-plugin
module.exports = {"searchWrapper":"AuditTemplateSearch__searchWrapper__120v5","icon":"AuditTemplateSearch__icon__20Qj8","clear":"AuditTemplateSearch__clear__129x-"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateSearch/AuditTemplateSearch.scss
// module id = 1651
// module chunks = 0